<mat-form-field class="search">
    <mat-label>Szukaj</mat-label>
    <input
    matInput
    (keyup)="applyFilter($event)"
    placeholder="Wyszukaj dane, np.:Jan Nowak"
    value="{{this.getFilterValue()}}"
    #filterValue
  />
  <button
    mat-button
    matSuffix 
    mat-icon-button
    (click)="filterValue.value='';this.applyFilterString('');"

> <mat-icon>close</mat-icon>
</button>
</mat-form-field>

<div>
  <table
    mat-table
    [dataSource]="this.peopleDataSource"
    class="mat-elevation-z8 table"
    matSort
  >
    <ng-container matColumnDef="lastName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Nazwisko</th>
      <td mat-cell *matCellDef="let element">{{ element.lastName?element.lastName:"-" }}</td>
    </ng-container>

    <ng-container matColumnDef="firstName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Imię</th>
      <td mat-cell *matCellDef="let element">{{ element.firstName?element.firstName:"-" }}</td>
    </ng-container>

    <ng-container matColumnDef="birthDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Data urodzenia</th>
      <td mat-cell *matCellDef="let element">{{ element.birthDate?element.birthDate:"-" }}</td>
    </ng-container>

    <ng-container matColumnDef="dateOfDeath">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Data śmierci</th>
      <td mat-cell *matCellDef="let element">{{ element.dateOfDeath?element.dateOfDeath:"-" }}</td>
    </ng-container>

    <ng-container matColumnDef="extraInfo">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Dodatkowe informacje
      </th>
      <td mat-cell *matCellDef="let element">{{ element.extraInfo?element.extraInfo:"-" }}</td>
    </ng-container>

    <ng-container matColumnDef="cemetery">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Cmentarz</th>
      <td mat-cell *matCellDef="let element">
        {{ element.tombstone.cemetery!="Wszystkie cmentarze"?element.tombstone.cemetery?element.tombstone.cemetery:"-":"-" }}
      </td>
    </ng-container>

    <ng-container matColumnDef="details">
      <th mat-header-cell *matHeaderCellDef>Szczegóły</th>
      <td mat-cell *matCellDef="let element">
        <button
          mat-raised-button
          style="background-color: #3d0300; color: #dbd9b8"
          (click)="this.goToTombstone(element.tombstone)"
        >
          Zobacz szczegóły
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="4">
        Nie znaleziono nic dla wyszukiwania: "{{ filterValue.value }}"
      </td>
    </tr>
  </table>
  <mat-paginator
    class="table"
    [pageSizeOptions]="[25, 50, 100]"
  ></mat-paginator>
</div>
